import { Comment } from '../../states/CommentState'
import {
  Image,
  LoginResponse,
  MapObject,
  Player,
  SessionKey,
  User
} from './payloads'

export const parseUser = (payload: any): User => ({
  id: payload.id,
  username: payload.username,
  displayName: payload.display_name,
  guest: payload.guest
})

export const parseSessionKey = (payload: any): SessionKey => ({
  id: payload.id,
  secretKey: payload.secret_key
})

export const parseLoginResponse = (payload: any): LoginResponse => ({
  user: parseUser(payload.user),
  sessionKeys: (payload.session_keys as Array<any>).map(parseSessionKey),
  privateChannel: payload.private_channel
})

export function parseImage (payload: any): Image {
  const image: Image = {
    id: payload.id,
    type: payload.type,
    name: payload.name,
    note: payload.note,
    imageURL: payload.url,
    thumbnailURL: payload.thumbnail_url,
    normalURL: payload.normal_url,
    socialMediaURL: payload.social_media_url,
    userID: payload.user.id,
    loved: payload.loved,
    createdAt: payload.created_at
  }
  return image
}

export function parsePlayer (payload: any): Player {
  const player: Player = {
    id: payload.id,
    type: payload.type,
    speed: payload.speed,
    displayName: payload.display_name,
    userID: payload.user.id,
    createdAt: payload.created_at
  }
  return player
}

export function parseMapObject (payload: any): MapObject {
  switch (payload.type) {
    case 'image':
      return parseImage(payload)
    case 'player':
      return parsePlayer(payload)
  }
  throw new Error(`Invalid map object type ${payload.type}`)
}

export function parseComment (payload: any): Comment {
  const comment: Comment = {
    id: payload.id,
    content: payload.content,
    name: payload.name,
    userID: payload.user.id
  }
  return comment
}

export function parseComments (payload: any): Array<Comment> {
  return (payload.map(parseComment) as Array<Comment>).reverse()
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/io/api-client/parsing.ts